// Mensajes del backend con datos variables (ver utils/toast.js): cada {{v0}}, {{v1}}…
// marca dónde el backend interpola un dato. Se extrajeron del código de los backends;
// para sumar uno, agregar aquí la clave y su traducción en i18n/locales/*/backend.json.
export const BACKEND_MESSAGE_TEMPLATES = [
  "\"{{v0}}\" no es un ID valido",
  "\"{{v0}}\" ya es el nombre canónico de {{v1}}: un alias acá taparía un problema del resolver en vez de arreglarlo",
  "Alcanzaste el máximo de {{v0}} carpetas",
  "Archivos enviados correctamente para el paquete {{v0}}",
  "Cada teléfono admite como máximo {{v0}} caracteres",
  "Canal no soportado para envio directo: {{v0}}",
  "Company not found. {{v0}}",
  "Company with ID {{v0}} not found",
  "CompanyIntegration not found for companyId {{v0}}",
  "Compañía con ID {{v0}} no encontrada",
  "Completa el campo \"{{v0}}\" antes de firmar.",
  "Conexión exitosa. {{v0}} tipos de documento disponibles.",
  "Contract with ID {{v0}} not found",
  "Country with ID {{v0}} not found",
  "Código postal duplicado en las tarifas por código postal: \"{{v0}}\" aparece en más de una regla {{v1}}",
  "Documento repetido: el folio {{v0}} del RUT {{v1}} ya está registrado en la semana del {{v2}}{{v3}}.",
  "El BFF rechazó el inicio de sesión (HTTP {{v0}})",
  "El CAF es del tipo {{v0}}, no del {{v1}} declarado.",
  "El ID de cuenta de Linkify no es válido (\"{{v0}}\"). No es tu correo ni el nombre de la cuenta: es el código que aparece en tu \"Link para pagar\" (app.linkify.cl/pay/ESTE-CÓDIGO/remote/...). También puedes pegar el link para pagar completo.",
  "El LPN '{{v0}}' no pertenece al seller '{{v1}}'.",
  "El RUT {{v0}} ya está registrado. Reintente.",
  "El alcance \"{{v0}}\" requiere un scopeId válido.",
  "El alias {{v0}} no existe",
  "El alta de couriers no está configurada en este entorno: falta {{v0}} en el gateway.",
  "El atajo \"{{v0}}\" ya está en uso por otra respuesta rápida",
  "El certificado está vencido (venció el {{v0}}). Sube uno vigente.",
  "El comercio {{v0}} no es una parada de la ruta {{v1}}",
  "El código postal \"{{v0}}\" está en más de una tarifa (también como \"{{v1}}\"). Cada código puede tener un solo precio.",
  "El destino respondió {{v0}}",
  "El estado '{{v0}}' no es un número válido.",
  "El estado debe ser uno de los siguientes valores: {{v0}}",
  "El logo es demasiado grande para la etiqueta térmica (máx {{v0}}×{{v1}} px). Generado: {{v2}}×{{v3}} px. Reduce el tamaño del logo.",
  "El lote supera el máximo de {{v0}} paquetes",
  "El mensaje no puede superar los {{v0}} caracteres",
  "El módulo '{{v0}}' no aplica a tenants de tipo '{{v1}}'",
  "El paquete cambió de estado y ya no se puede marcar como entregado (estado actual: {{v0}}).",
  "El paquete ya cambió de estado ({{v0}}); no se puede registrar una entrega fallida. Actualiza tu lista de entregas.",
  "El paquete {{v0}} no se puede poner en ruta porque está en estado \"{{v1}}\".",
  "El país '{{v0}}' no está disponible para el registro.",
  "El período no puede superar {{v0}} días.",
  "El pre-documento debe estar en estado \"approved\" para enviarse a BSale. Estado actual: \"{{v0}}\"",
  "El pre-documento ya fue enviado a BSale con id={{v0}}",
  "El rango de fechas excede {{v0}} días. Para rangos mayores use el sistema de reportes asíncronos (POST /requests).",
  "El rango de fechas no es válido (máximo {{v0}} días)",
  "El rango no puede superar {{v0}} días (solicitado: {{v1}})",
  "El rango solicitado es anterior a la primera fecha con datos de entrega ({{v0}})",
  "El status del body ({{v0}}) no coincide con el status de la URL ({{v1}}).",
  "El tamaño \"{{v0}}\" está configurado más de una vez. Cada categoría puede tener un solo recargo.",
  "El transporte \"{{v0}}\" sólo aplica a suscripciones de alcance \"platform\".",
  "Error actualizando el paquete {{v0}} con las imágenes",
  "Error al actualizar el vehículo: {{v0}}",
  "Error al agregar el vehículo: {{v0}}",
  "Error al crear paquete MercadoLibre: {{v0}}",
  "Error al eliminar la ruta{{v0}}: {{v1}}",
  "Error al enviar los archivos para el paquete {{v0}}.",
  "Error al intentar obtener paquetes: {{v0}}.",
  "Error al procesar archivos del vehículo: {{v0}}",
  "Error connection api mercadolibre. ({{v0}})",
  "Error connection api ms-s3-ots después de {{v0}} intentos",
  "Error connection api ms-s3-ots: {{v0}}",
  "Error connection api packages/insert-unified: {{v0}}",
  "Error connection api packages/update-status: {{v0}}",
  "Error creando informe de entrega: {{v0}}",
  "Error creating position: {{v0}}",
  "Error de Meta #{{v0}}",
  "Error enviando resúmenes de entrega: {{v0}}",
  "Error in process generate token MERCADOLIBRE USER:{{v0}}",
  "Error procesando escaneo: {{v0}}",
  "Error sending email: {{v0}}",
  "Error subiendo la evidencia a S3 (revisa MS_S3_OTS_URL del microservicio): {{v0}}",
  "Error tras {{v0}} reintentos: {{v1}}",
  "Este {{v0}} ya está registrado.",
  "Estos correos no corresponden a un usuario de tu comercio: {{v0}}",
  "Estos códigos postales no son válidos para tarifar: {{v0}}. Se espera un CPA argentino de 8 caracteres (M5500ABC) o un código de 4 dígitos (5500).",
  "Estos usuarios no son repartidores de tu empresa (o son freelancer): {{v0}}",
  "Estás a {{v0}} m de {{v1}}. Solo puedes quitar pedidos de la ruta a menos de {{v2}} m de una bodega.",
  "Falabella aceptó el request pero rechazó {{v0}} de {{v1}} updates (processedCount={{v2}})",
  "Falabella no tiene una orden para el LPN {{v0}}.",
  "Fallo transitorio al refrescar token MeLi para userId {{v0}}",
  "Fecha o zona horaria no válida: {{v0}} / {{v1}}",
  "Fila {{v0}}: fecha inválida (YYYY-MM-DD)",
  "Fila {{v0}}: monto inválido (≠ 0)",
  "Fila {{v0}}: motivo requerido",
  "Fila {{v0}}: repartidor inválido",
  "HTTP {{v0}} sin cuerpo de error de Meta",
  "Hay dos montos configurados para el mismo líder de flota ({{v0}}).",
  "Integration with id {{v0}} not found for this company.",
  "Invalid ID format: {{v0}}",
  "La autenticación \"{{v0}}\" requiere que envíes el secreto.",
  "La capacidad '{{v0}}' no permite escritura",
  "La capacidad {{v0}} no está disponible para la audiencia {{v1}}",
  "La comuna \"{{v0}}\" está en más de una tarifa (también como \"{{v1}}\"). Cada comuna puede tener un solo precio.",
  "La comuna {{v0}} no existe en el catálogo de {{v1}}",
  "La comuna {{v0}} no pertenece a la región {{v1}}.",
  "La comunicación supera el máximo de {{v0}} destinatarios. Acota los filtros.",
  "La escala {{v0}} tiene dos tramos que empiezan en {{v1}} paquetes. Cada tramo debe empezar en una cantidad distinta.",
  "La escala {{v0}} tiene que empezar en 0 paquetes: hoy arranca en {{v1}} y los comercios por debajo de esa cantidad quedarían sin precio escalonado.",
  "La parada {{v0}} no pertenece al comercio {{v1}} en esta ruta",
  "La región {{v0}} no pertenece al país de operación de la empresa.",
  "La ruta {{v0}} no existe",
  "La semana del {{v0}} sigue abierta",
  "La web {{v0}} no está autorizada.",
  "Limite de instancias WhatsApp No Oficial alcanzado ({{v0}}). Contacta a soporte para aumentar el limite.",
  "Logistics company with ID {{v0}} not found",
  "Los tramos {{v0}}–{{v1}} y {{v2}}–{{v3}} se solapan.",
  "Límite de {{v0}} adjuntos por card alcanzado.",
  "Límite de {{v0}} checklists por card alcanzado.",
  "Límite de {{v0}} listas por tablero alcanzado.",
  "Límite de {{v0}} tableros activos alcanzado.",
  "Límite de {{v0}} ítems por checklist alcanzado.",
  "Meli integration with userId {{v0}} not found.",
  "Mensaje no enviado a {{v0}}",
  "MercadoLibre no integrado o sin token para userId {{v0}}",
  "MercadoLibre no integrado para userId {{v0}}",
  "No active contract found for company {{v0}}",
  "No existe el tenant de tipo '{{v0}}' con id {{v1}}",
  "No hay paquetes pendientes con la comuna \"{{v0}}\" en {{v1}}",
  "No hay tarifa ni configuración de pago para driverId={{v0}}",
  "No hay una company registrada para el sellerId '{{v0}}'. Registrar primero la integración Falabella Directo.",
  "No integrations found for companyId {{v0}}",
  "No operations address with shippingLocation = true found for logistics company {{v0}}",
  "No pudimos completar tu registro: {{v0}}",
  "No pudimos crear la cuenta: {{v0}}",
  "No pudimos crear tu cuenta: {{v0}}",
  "No puedes crear suscripciones de alcance \"{{v0}}\".",
  "No se encontraron contratos activos para la empresa logística con ID {{v0}}",
  "No se encontraron imágenes subidas para el paquete {{v0}} con status {{v1}}. Por favor vuelve a subir las fotos de evidencia e intenta nuevamente.",
  "No se encontro ubicacion para el driver {{v0}}",
  "No se encontró configuración BSale activa para logisticCompanyId={{v0}}",
  "No se encontró contrato activo entre logisticCompanyId={{v0}} y companyId={{v1}}",
  "No se encontró el comprobante de la transferencia para el paquete {{v0}} con status {{v1}}. El pago por transferencia exige la foto del comprobante: vuelve a subirla e intenta nuevamente.",
  "No se encontró la foto del producto devuelto para el paquete {{v0}}. El retiro del producto exige al menos una foto: vuelve a subirla e intenta nuevamente.",
  "No se encontró un vehículo con la patente {{v0}}",
  "No se pudo conectar al microservicio de location tracking: {{v0}}",
  "No se pudo crear el paquete después de {{v0}} intentos",
  "No se pudo crear el paquete {{v0}}: {{v1}}",
  "No se pudo obtener la orden {{v0}} desde Falabella.",
  "No se pudo verificar el paquete {{v0}} en microservice-packages (status {{v1}}).",
  "No se puede aprobar un pre-documento en estado \"{{v0}}\"",
  "No se puede asociar a un repartidor que ya lidera su propia flota: {{v0}}",
  "No se puede editar un pre-documento en estado \"{{v0}}\"",
  "No se puede rechazar un pre-documento en estado \"{{v0}}\"",
  "No se pueden tener más de {{v0}} credenciales activas. Revocá una antes de crear otra.",
  "No shipping address of type 'BODEGA' found for company {{v0}}",
  "Nota de cobro {{v0}} no encontrada",
  "Número de teléfono inválido: \"{{v0}}\" → \"{{v1}}\" (mínimo 8 dígitos requeridos)",
  "Order ID {{v0}} already exists for this sender",
  "Paquete actualizado correctamente con {{v0}} archivo(s)",
  "Paquete con ID {{v0}} no encontrado",
  "Paquete con _id {{v0}} no encontrado.",
  "Paquete con followingNumber {{v0}} no encontrado",
  "Paquete con followingNumber {{v0}} no encontrado.",
  "Paquete con order_id {{v0}} y seller {{v1}} no encontrado.",
  "Paquete {{v0}} no encontrado.",
  "Paquete {{v0}}: cambió de estado mientras se actualizaba",
  "Paquete {{v0}}: no cumple la guarda del cambio de producto ({{v1}})",
  "Parámetro \"{{v0}}\" inválido: excede el largo máximo permitido",
  "Parámetro \"{{v0}}\" inválido: se esperaba un único valor escalar",
  "Parámetro no soportado: \"{{v0}}\"",
  "Pickup {{v0}} no encontrado",
  "Position with code {{v0}} already exists for this company",
  "Pre-documento {{v0}} no encontrado",
  "Proposal with ID {{v0}} not found",
  "Proveedor no soportado: {{v0}}",
  "Quedan pedidos sin precio entre {{v0}} y {{v1}}.",
  "Recolección {{v0}} no encontrada",
  "Refresh de token MeLi en curso para userId {{v0}}, reintentar",
  "Region with ID {{v0}} not found",
  "Respuesta inesperada del servicio (status: {{v0}}).",
  "Rol '{{v0}}' no autorizado para listar collects",
  "Rol '{{v0}}' no autorizado para listar pickups",
  "Ruta {{v0}} no encontrada en su scope",
  "Sender ID not found in integration for companyId {{v0}}",
  "Shipping address with ID {{v0}} not found for company {{v1}}",
  "Shopify Access Token Error: {{v0}}",
  "Se alcanzó el máximo de {{v0}} avisos vigentes o próximos; elimina alguno antes de crear otro.",
  "Sin conexión con Meta ({{v0}}): el mensaje no llegó a enviarse",
  "Sólo el superadministrador del sistema puede {{v0}}",
  "Tarifa {{v0}} no encontrada",
  "Tipo de QR no soportado: {{v0}}",
  "Tipo de archivo no permitido ({{v0}}). Permitidos: imágenes, PDF, Office, texto.",
  "Token could not be generated COMPANY:{{v0}}",
  "Token de MercadoLibre vencido o ausente para userId {{v0}}",
  "Token generated successfully COMPANY:{{v0}}",
  "Token is already generated COMPANY:{{v0}}",
  "Unsupported file type {{v0}}",
  "Validación con IA no disponible: {{v0}}",
  "Validation failed with following Errors: {{v0}}",
  "Variables desconocidas en el mensaje: {{v0}}",
  "Ventana de mensajeria expirada. Usa un Template Message para contactar a {{v0}}.",
  "Versión incompatible. Versión actual requerida: {{v0}}. Por favor actualiza tu aplicación.",
  "Versión incompatible. Versión actual: {{v0}}. Por favor actualiza tu aplicación.",
  "Wix: integración {{v0}} sin sender_id; no se encola para no duplicar paquetes en los reintentos",
  "Wix: pedido sin id en la instancia {{v0}}; no se encola para no duplicar paquetes en los reintentos",
  "Ya alcanzaste el máximo de {{v0}} agentes",
  "Ya existe un paquete con el número de venta \"{{v0}}\" para esta empresa. Por favor, corrija los datos e intente nuevamente.",
  "Ya hay {{v0}} comunicaciones en curso. Espera a que terminen o cancela alguna.",
  "Zona horaria IANA no válida: {{v0}}",
  "area debe ser una de: {{v0}}",
  "audience debe ser uno de: {{v0}}",
  "billingDocType debe ser uno de: {{v0}}",
  "channel debe ser uno de: {{v0}}",
  "clients.{{v0}}.shippingAddress es requerido (envía shippingAddress o selectedAddress).",
  "color debe ser uno de: {{v0}}",
  "content-type no es imagen: {{v0}}",
  "country requiere 'code' ({{v0}}) o el contrato legacy con 'name' ({{v1}})",
  "country.code debe ser uno de: {{v0}}",
  "deductionIndex {{v0}} fuera de rango",
  "effect debe estar entre {{v0}} y {{v1}}",
  "email no puede superar los {{v0}} caracteres",
  "foto excede {{v0}} bytes",
  "granularidad no soportada: {{v0}}",
  "ids admite como máximo {{v0}} elementos",
  "kind debe ser uno de: {{v0}}",
  "limit admite como máximo {{v0}}",
  "limite diario de acciones alcanzado ({{v0}})",
  "lineItemIndex {{v0}} fuera de rango",
  "métrica no soportada: {{v0}}",
  "orderId admite como máximo {{v0}} caracteres",
  "password debe tener al menos {{v0}} caracteres",
  "password no puede superar los {{v0}} caracteres",
  "path debe empezar con {{v0}}",
  "phones admite como máximo {{v0}} teléfonos",
  "provider debe ser uno de: {{v0}}",
  "read solo admite capacidades del catálogo ({{v0}})",
  "role debe ser uno de: {{v0}}",
  "scope no soportado: {{v0}}",
  "sellerId '{{v0}}' no encontrado en las integraciones de la company.",
  "status debe ser uno de: {{v0}}",
  "vehicleType debe ser uno de: {{v0}}",
  "vehicleType duplicado en vehicleRates: {{v0}}",
  "webhook devolvió {{v0}}: {{v1}} (delivery={{v2}})",
  "window fuera de rango (0, {{v0}}d]",
  "write solo admite capacidades del catálogo ({{v0}})",
  "{{v0}} debe ser YYYY-MM-DD",
  "{{v0}} el número de venta ya existe para el vendedor",
  "{{v0}} is not a valid email address",
  "{{v0}} no es un ObjectId válido",
  "{{v0}} no es un id válido",
  "{{v0}}, record could not be created",
];
